
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/Button";

const EducationHero = () => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background/80 z-0"></div>
      
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 z-0">
        <div className="absolute top-1/4 left-1/3 w-96 h-96 rounded-full bg-blue-600 filter blur-[120px]"></div>
        <div className="absolute bottom-1/4 right-1/3 w-80 h-80 rounded-full bg-purple-600 filter blur-[100px]"></div>
      </div>
      
      <div className="container mx-auto relative z-10 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            Comprehensive <span className="text-gradient">AI Training</span> for Legal Professionals
          </h1>
          
          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-3xl mx-auto">
            Master the latest AI tools and methodologies designed specifically for legal practice with our customized education programs.
          </p>
          
          <div className="flex flex-wrap gap-4 justify-center">
            <Button variant="glass" size="lg" className="text-base">
              Request a Consultation
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            
            <Button variant="outline" size="lg" className="text-base">
              View Curriculum
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationHero;
